module.exports = __webpack_public_path__ + "images/winston-ling.dcaf0b93c4afcf0f850ec0714aa8c3cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/winston-ling.jpeg
// module id = 1034
// module chunks = 0